import { datetime } from "../../utils";

export const mapCard = (json) => {
    const {
        projectId,
        importId,
        fiscalYear,
        createdAt,
        createdBy,
        entityStructure,
        newValue,
        oldValue,
        field,
        configSet,
    } = json;

    return [
        [
            {
                labels: ["Project"],
                value: projectId,
                type: "string",
            },
        ],
        [
            {
                labels: ["Import ID"],
                value: importId,
                type: "string",
            },
        ],
        [
            {
                labels: ["Fiscal Year"],
                value: fiscalYear,
                type: "string",
            },
        ],
        [
            {
                labels: ["Dataset Locale"],
                value: configSet,
                type: "string",
            },
        ],
        [
            {
                labels: ["Entity"],
                value: entityStructure,
                type: "string",
            },
        ],
        [
            {
                labels: ["Field"],
                value: field?.split(".")?.[1] || "N/A",
                type: "string",
            },
        ],
        [
            {
                labels: ["Old Value"],
                value: oldValue,
                type: "string",
            },
        ],
        [
            {
                labels: ["New Value"],
                value: newValue,
                type: "string",
            },
        ],
        [
            {
                labels: ["Created At"],
                value: datetime(createdAt),
                type: "string",
            },
        ],
        [
            {
                labels: ["Created By"],
                value: createdBy,
                type: "string",
            },
        ],
    ];
};

const header = [
    {
        label: ["Project"],
        align: "center",
        columnName: "projectId",
        sortable: true,
    },
    {
        label: ["Import ID"],
        align: "center",
        columnName: "importId",
        sortable: true,
    },
    {
        label: ["Fiscal Year"],
        align: "center",
        columnName: "fiscalYear",
        sortable: true,
    },
    {
        label: ["Dataset Locale"],
        align: "center",
        columnName: "configSet",
        sortable: true,
    },
    {
        label: ["Entity"],
        align: "center",
        columnName: "entityStructure",
        sortable: true,
    },
    {
        label: ["Field"],
        align: "left",
        columnName: "field",
        sortable: true,
    },
    {
        label: ["Old Value"],
        align: "center",
        columnName: "oldValue",
        sortable: true,
    },
    {
        label: ["New Value"],
        align: "center",
        columnName: "newValue",
        sortable: true,
    },
    {
        label: ["Created At"],
        align: "center",
        columnName: "createdAt",
        sortable: true,
    },
    {
        label: ["Created By"],
        align: "center",
        columnName: "createdBy",
        sortable: true,
    },
];

const translationtableupdatelogMapper = {
    map: (json) => {
        return {
            ...json,
            card: mapCard(json),
        };
    },
    header,
};

export default translationtableupdatelogMapper;
